import React from 'react';
import { PaperClipOutlined, PictureOutlined } from '@ant-design/icons';
import { space, icon, radius, shadow, hoverBg, accent, fontWeight, bg } from '../configs/designTokens';

const DragDropText = () => {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: hoverBg.primary,
        zIndex: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: `2px dashed ${accent.primary}`,
        borderRadius: radius.xs,
      }}
    >
      <div
        style={{
          backgroundColor: bg.card,
          padding: space[5],
          borderRadius: radius.md,
          boxShadow: shadow.md,
          textAlign: 'center',
        }}
      >
        <div
          style={{
            fontSize: icon.xxl,
            marginBottom: space[2],
          }}
        >
          <PaperClipOutlined style={{ marginRight: space[2] }} />
          <PictureOutlined />
        </div>
        <div style={{ fontWeight: fontWeight.semibold }}>Drop files here</div>
      </div>
    </div>
  );
};

export default DragDropText;
